import env from "@/env";
import { apiContract } from "@repo/api";
import { initTsrReactQuery } from "@ts-rest/react-query/v5";
import Cookies from "js-cookie";

const getAuthToken = (): string => {
  return Cookies.get("stytch_session_jwt") || "";
};

const clientOptions = {
  baseUrl: env.VITE_API_URL,
  baseHeaders: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
};

export const tsr = initTsrReactQuery(apiContract, clientOptions);
